import React from 'react';
import ReactFlow, { 
  Background, 
  Controls, 
  MiniMap,
  Handle,
  Position,
  MarkerType
} from 'reactflow';
import 'reactflow/dist/style.css';

const ArtemisIntellectualProperty = () => {
  const nodes = [
    {
      id: '1',
      type: 'input',
      data: { 
        label: (
          <div style={{ padding: '15px', textAlign: 'center' }}>
            <strong style={{ fontSize: '18px' }}>⚡ Artemis Engine</strong>
            <div style={{ fontSize: '14px', marginTop: '8px', color: '#F57C00' }}>
              Intellectual Property Protection Framework
            </div>
            <div style={{ fontSize: '12px', marginTop: '5px', color: '#666' }}>
              Protecting Code Evolution & Optimization Technology
            </div>
          </div>
        )
      },
      position: { x: 400, y: 0 },
      style: {
        background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
        border: '3px solid #F57C00',
        borderRadius: '12px',
        width: 350,
        boxShadow: '0 4px 12px rgba(245, 124, 0, 0.3)'
      }
    },
    
    // Core Innovation
    {
      id: 'core-innovation',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>🚀 Core Innovation Assets</strong>
          </div>
        )
      },
      position: { x: 375, y: 140 },
      style: {
        background: '#fff8e1',
        border: '2px solid #FF9800',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // Evolution Technology
    {
      id: 'evolution-tech',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#E65100' }}>🧬 Evolution Technology</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Genetic programming algorithms</li>
              <li>Multi-objective fitness functions</li>
              <li>Population management strategies</li>
              <li>Crossover & mutation operators</li>
              <li>Adaptive evolution parameters</li>
              <li>Convergence optimization</li>
            </ul>
          </div>
        )
      },
      position: { x: 50, y: 250 },
      style: {
        background: '#ffffff',
        border: '2px solid #FFB74D',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Code Analysis
    {
      id: 'code-analysis',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#E65100' }}>🔍 Code Analysis IP</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>AST manipulation techniques</li>
              <li>Static code analysis methods</li>
              <li>Performance profiling algorithms</li>
              <li>Code pattern recognition</li>
              <li>Dependency graph analysis</li>
              <li>Language-agnostic parsing</li>
            </ul>
          </div>
        )
      },
      position: { x: 360, y: 250 },
      style: {
        background: '#ffffff',
        border: '2px solid #FFB74D',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Optimization Methods
    {
      id: 'optimization',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#E65100' }}>⚙️ Optimization Methods</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Test generation algorithms</li>
              <li>Benchmark creation methods</li>
              <li>Performance optimization rules</li>
              <li>Memory usage reduction</li>
              <li>Parallelization strategies</li>
              <li>Code refactoring patterns</li>
            </ul>
          </div>
        )
      },
      position: { x: 670, y: 250 },
      style: {
        background: '#ffffff',
        border: '2px solid #FFB74D',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Patent Portfolio
    {
      id: 'patents',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>📜 Patent Portfolio</strong>
          </div>
        )
      },
      position: { x: 375, y: 450 },
      style: {
        background: '#fce4ec',
        border: '2px solid #C2185B',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // Filed Patents
    {
      id: 'filed-patents',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#880E4F' }}>📑 Filed Patents</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Automated code evolution system</li>
              <li>Multi-objective code optimization</li>
              <li>Test generation methodology</li>
              <li>AST-based transformations</li>
              <li>Performance prediction models</li>
              <li>Cross-language optimization</li>
            </ul>
          </div>
        )
      },
      position: { x: 120, y: 560 },
      style: {
        background: '#ffffff',
        border: '2px solid #F06292',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Trade Secrets
    {
      id: 'trade-secrets',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#880E4F' }}>🔒 Trade Secrets</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Fitness function formulations</li>
              <li>Evolution parameter tuning</li>
              <li>Population diversity metrics</li>
              <li>Convergence accelerators</li>
              <li>Custom operator implementations</li>
              <li>Performance benchmarks</li>
            </ul>
          </div>
        )
      },
      position: { x: 430, y: 560 },
      style: {
        background: '#ffffff',
        border: '2px solid #F06292',
        borderRadius: '8px',
        width: 280
      }
    },
    
    // Protection Strategy
    {
      id: 'protection-strategy',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>🛡️ Protection Strategy</strong>
          </div>
        )
      },
      position: { x: 375, y: 720 },
      style: {
        background: '#e8eaf6',
        border: '2px solid #5C6BC0',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // Technical Measures
    {
      id: 'tech-measures',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#311B92' }}>💻 Technical Measures</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Core engine obfuscation</li>
              <li>License key validation</li>
              <li>Encrypted communication</li>
              <li>Tamper detection</li>
              <li>Runtime protection</li>
              <li>Secure deployment</li>
            </ul>
          </div>
        )
      },
      position: { x: 20, y: 830 },
      style: {
        background: '#ffffff',
        border: '2px solid #7986CB',
        borderRadius: '8px',
        width: 260
      }
    },
    
    // Legal Measures
    {
      id: 'legal-measures',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#311B92' }}>⚖️ Legal Measures</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Patent enforcement</li>
              <li>License agreements</li>
              <li>Copyright protection</li>
              <li>Trade secret law</li>
              <li>Contractual obligations</li>
              <li>IP insurance</li>
            </ul>
          </div>
        )
      },
      position: { x: 310, y: 830 },
      style: {
        background: '#ffffff',
        border: '2px solid #7986CB',
        borderRadius: '8px',
        width: 260
      }
    },
    
    // Usage Control
    {
      id: 'usage-control',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#311B92' }}>📊 Usage Control</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>API usage tracking</li>
              <li>Feature access control</li>
              <li>Execution monitoring</li>
              <li>Output watermarking</li>
              <li>Compliance reporting</li>
              <li>Audit mechanisms</li>
            </ul>
          </div>
        )
      },
      position: { x: 600, y: 830 },
      style: {
        background: '#ffffff',
        border: '2px solid #7986CB',
        borderRadius: '8px',
        width: 260
      }
    },
    
    // User Guidelines
    {
      id: 'guidelines',
      data: { 
        label: (
          <div style={{ padding: '12px', textAlign: 'center' }}>
            <strong style={{ fontSize: '16px' }}>📋 Implementation Guidelines</strong>
          </div>
        )
      },
      position: { x: 375, y: 990 },
      style: {
        background: '#e8f5e9',
        border: '2px solid #43A047',
        borderRadius: '8px',
        width: 250
      }
    },
    
    // User Responsibilities
    {
      id: 'user-resp',
      data: { 
        label: (
          <div style={{ padding: '10px' }}>
            <strong style={{ color: '#1B5E20' }}>✅ User Compliance</strong>
            <ul style={{ fontSize: '12px', textAlign: 'left', margin: '10px 0', paddingLeft: '20px' }}>
              <li>Honor licensing terms</li>
              <li>Protect access credentials</li>
              <li>No reverse engineering</li>
              <li>Respect usage limits</li>
              <li>Maintain confidentiality</li>
              <li>Report violations</li>
            </ul>
          </div>
        )
      },
      position: { x: 250, y: 1100 },
      style: {
        background: '#ffffff',
        border: '2px solid #66BB6A',
        borderRadius: '8px',
        width: 500
      }
    }
  ];

  const edges = [
    {
      id: 'e1-2',
      source: '1',
      target: 'core-innovation',
      type: 'smoothstep',
      animated: true,
      style: { stroke: '#FF9800', strokeWidth: 2 }
    },
    {
      id: 'e2-3',
      source: 'core-innovation',
      target: 'evolution-tech',
      type: 'smoothstep'
    },
    {
      id: 'e2-4',
      source: 'core-innovation',
      target: 'code-analysis',
      type: 'smoothstep'
    },
    {
      id: 'e2-5',
      source: 'core-innovation',
      target: 'optimization',
      type: 'smoothstep'
    },
    {
      id: 'e3-6',
      source: 'evolution-tech',
      target: 'patents',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e4-6',
      source: 'code-analysis',
      target: 'patents',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e5-6',
      source: 'optimization',
      target: 'patents',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e6-7',
      source: 'patents',
      target: 'filed-patents',
      type: 'smoothstep'
    },
    {
      id: 'e6-8',
      source: 'patents',
      target: 'trade-secrets',
      type: 'smoothstep'
    },
    {
      id: 'e7-9',
      source: 'filed-patents',
      target: 'protection-strategy',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e8-9',
      source: 'trade-secrets',
      target: 'protection-strategy',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e9-10',
      source: 'protection-strategy',
      target: 'tech-measures',
      type: 'smoothstep'
    },
    {
      id: 'e9-11',
      source: 'protection-strategy',
      target: 'legal-measures',
      type: 'smoothstep'
    },
    {
      id: 'e9-12',
      source: 'protection-strategy',
      target: 'usage-control',
      type: 'smoothstep'
    },
    {
      id: 'e10-13',
      source: 'tech-measures',
      target: 'guidelines',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e11-13',
      source: 'legal-measures',
      target: 'guidelines',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e12-13',
      source: 'usage-control',
      target: 'guidelines',
      type: 'smoothstep',
      markerEnd: { type: MarkerType.ArrowClosed }
    },
    {
      id: 'e13-14',
      source: 'guidelines',
      target: 'user-resp',
      type: 'smoothstep'
    }
  ];

  return (
    <div style={{ width: '100%', height: '100vh' }}>
      <div style={{ 
        background: 'linear-gradient(135deg, #ffffff 0%, #fff8e1 100%)', 
        padding: '20px',
        borderBottom: '2px solid #F57C00',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ margin: 0, fontSize: '28px', color: '#E65100' }}>
          ⚡ Artemis Engine - Intellectual Property Protection
        </h1>
        <p style={{ margin: '10px 0 0 0', color: '#666', fontSize: '16px' }}>
          Comprehensive framework for protecting code evolution and optimization technology
        </p>
      </div>
      
      <div style={{ width: '100%', height: 'calc(100% - 120px)' }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          fitView
          attributionPosition="bottom-left"
        >
          <Background color="#ddd" gap={20} />
          <Controls />
          <MiniMap 
            style={{
              height: 120,
              backgroundColor: '#f8f8f8',
              border: '1px solid #ddd'
            }}
            maskColor="rgb(50, 50, 50, 0.8)"
          />
        </ReactFlow>
      </div>
    </div>
  );
};

export default ArtemisIntellectualProperty; 